
















import { Component, Vue, Inject, Watch, Prop } from 'vue-property-decorator';
import { RouteRecord } from 'vue-router';

@Component
export default class Message extends Vue {
  public get routes(): any {
    const router = this.$route as any;
    return router.matched.filter((item: RouteRecord) => item.meta && item.meta.routerName);
  }
}
